import { render } from "./ViewSettings.vue?vue&type=template&id=2af4d582&scoped=true&ts=true"
import script from "./ViewSettings.vue?vue&type=script&lang=ts"
export * from "./ViewSettings.vue?vue&type=script&lang=ts"

import "./ViewSettings.vue?vue&type=style&index=0&id=2af4d582&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af4d582"]])

export default __exports__